<p-toast></p-toast>

<ng-container *ngIf="display === 'dialog'">
    <button pButton label="Notifications" type="button" icon="pi pi-bell" (click)="showDialog()" class="mr-2"
        style="position: relative;" severity="warn">
        <p-badge [value]="getUnreadCount()" severity="danger" *ngIf="getUnreadCount() > 0"
            [style]="{'position': 'absolute', 'top': '0', 'right': '0'}"></p-badge>
    </button>

    <p-dialog header="Notifications" [(visible)]="visible" [modal]="true" [style]="{width: '70vw'}" [draggable]="false">
        <ng-template pTemplate="header">
            <div class="flex justify-content-between align-items-center w-full">
                <span class="p-dialog-title">Notifications</span>
                <div>
                    <button pButton type="button" label="Mark All as Read" (click)="markAllAsRead()"
                        class="p-button-text p-button-sm" [disabled]="getUnreadCount() === 0"></button>
                    <button pButton type="button" icon="pi pi-refresh" (click)="loadNotifications()" [loading]="loading"
                        class="p-button-text p-button-rounded p-button-sm ml-2"></button>
                </div>
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
    </p-dialog>
</ng-container>

<div class="card" *ngIf="display === 'inline'">
    <div class="flex justify-content-between align-items-center w-full mb-3">
        <h3 class="m-0">Notifications</h3>
        <div>
            <button pButton type="button" label="Mark All as Read" (click)="markAllAsRead()"
                class="p-button-text p-button-sm" [disabled]="getUnreadCount() === 0"></button>
            <button pButton type="button" icon="pi pi-refresh" (click)="loadNotifications()" [loading]="loading"
                class="p-button-text p-button-rounded p-button-sm ml-2"></button>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
</div>

<ng-template #notificationContent>
    <div *ngIf="loading" class="flex justify-content-center p-4">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
    </div>
    <div *ngIf="!loading && notifications.length > 0" class="notification-list">
        <div *ngFor="let notification of notifications" class="notification-item p-3 border-bottom-1 surface-border"
            [class.unread]="!notification.read" (click)="onNotificationClick(notification)">
            <div class="flex align-items-start">
                <div class="mr-3">
                    <i [class]="notification.icon || 'pi pi-info-circle'" [ngClass]="'text-' + notification.severity"
                        style="font-size: 1.5rem"></i>
                </div>
                <div class="flex-grow-1">
                    <div [innerHTML]="notification.message"></div>
                    <div class="text-sm text-color-secondary mt-1">
                        {{ notification.createdAt | appDate:'short' }}
                    </div>
                </div>
                <div *ngIf="!notification.read" class="ml-3">
                    <button pButton type="button" icon="pi pi-circle-fill"
                        class="p-button-text p-button-rounded p-button-sm" pTooltip="Mark as read"
                        tooltipPosition="left" (click)="markAsRead(notification, $event)"></button>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading && notifications.length === 0" class="text-center p-4">
        <i class="pi pi-bell" style="font-size: 2rem"></i>
        <p>You have no notifications.</p>
    </div>
</ng-template>